import React, { useState } from 'react';

const CommentContent = () => {
    const [comments, setComments] = useState([
        { id: 1, name: 'John Doe', text: 'This is a great proposal!', date: '2024-02-20' },
        { id: 2, name: 'Jane Smith', text: 'Looking forward to the next update.', date: '2024-02-21' },
        { id: 3, name: 'Alice Johnson', text: 'Can we add more details to the timeline?', date: '2024-02-22' },
        { id: 4, name: 'Bob Williams', text: 'Great work so far!', date: '2024-02-23' }
    ]);
    const [newComment, setNewComment] = useState('');

    const handleCommentSubmit = (e) => {
        e.preventDefault();
        if (newComment.trim() === '') return;

        const newCommentObj = {
            id: comments.length + 1,
            name: 'You',
            text: newComment,
            date: new Date().toISOString().split('T')[0]
        };

        setComments([...comments, newCommentObj]);
        setNewComment('');
    };

    return (
            <div className="card">
                <div className="card-body">
                    <h4 className="mb-4">Comments</h4>

                    {/* Scrollable Comment List */}
                    <div className="mb-4 border rounded overflow-auto" style={{ maxHeight: '300px' }}>
                        {comments.length > 0 ? (
                            comments.map(comment => (
                                <div key={comment.id} className="border-bottom p-3">
                                    <div className="d-flex justify-content-between">
                                        <h6 className="mb-1">{comment.name}</h6>
                                        <small className="text-body-secondary">{comment.date}</small>
                                    </div>
                                    <p className="mb-0">{comment.text}</p>
                                </div>
                            ))
                        ) : (
                            <p className="text-body-secondary p-3">No comments yet. Be the first to comment!</p>
                        )}
                    </div>

                    {/* Comment Form */}
                    <form onSubmit={handleCommentSubmit}>
                        <div className="mb-3">
                            <label htmlFor="comment" className="form-label">Add a comment</label>
                            <textarea
                                id="comment"
                                className="form-control"
                                rows="3"
                                value={newComment}
                                onChange={(e) => setNewComment(e.target.value)}
                                placeholder="Write your comment here..."
                                required
                            />
                        </div>
                        <button type="submit" className="btn btn-primary btn-sm">Submit</button>
                    </form>
                </div>
            </div>
    );
};

export default CommentContent;
